import * as React from 'react'

import { ComplaintHeaderDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const ComplaintHeader = React.lazy(
  () => import('modules/complaints/pages/ComplaintDetailPage/ComplaintHeader')
)
const ComplaintsPage = React.lazy(() => import('modules/complaints/pages/ComplaintsPage'))
const ComplaintsShowPage = React.lazy(() => import('modules/complaints/pages/ComplaintsShowPage'))
const ComplaintDetailPage = React.lazy(() => import('modules/complaints/pages/ComplaintDetailPage'))
const ComplaintOverview = React.lazy(
  () => import('modules/complaints/pages/ComplaintDetailPage/ComplaintOverview')
)
const ComplaintActivity = React.lazy(
  () => import('modules/complaints/pages/ComplaintDetailPage/ComplaintActivity')
)
const RootPage = React.lazy(() => import('modules/complaints/pages/RootPage'))

export const complaintsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.complaints.path,
      element: <RootPage />,
      handle: {
        module: 'complaints',
        meta: () => {
          return {
            title: i18n.t('complaints.title'),
            description: i18n.t('complaints.header.description'),
            illustration: 'complaints',
            settings: navigation.settings.complaints.fullPath(),
          }
        },
      },
      children: [
        {
          index: true,
          element: <ComplaintsPage />,
        },
        {
          path: navigation.complaints.id.path,
          element: <ComplaintDetailPage />,
          handle: {
            resource: true,
            meta: ({ watchQuery, params }) => {
              if (!params.id) {
                return { title: '' }
              }

              return watchQuery({
                query: ComplaintHeaderDocument,
                variables: {
                  id: Number(params.id),
                },
              }).map(({ data }) => {
                const complaint = data.complaints.complaint

                if (!complaint) {
                  return { title: '' }
                }

                const subject = complaint.identifier || `Complaint #${complaint.id}`

                return {
                  title: subject,
                  headerComponent: <ComplaintHeader complaint={complaint} />,
                  subNavigation: [
                    {
                      title: i18n.t('complaints.tabs.overview'),
                      href: navigation.complaints.id.fullPath({ id: complaint.id }),
                      index: true,
                    },
                    {
                      title: i18n.t('complaints.tabs.messsages'),
                      href: navigation.complaints.id.messages.fullPath({ id: complaint.id }),
                    },
                  ],
                }
              })
            },
          },
          children: [
            {
              index: true,
              element: <ComplaintOverview />,
            },
            {
              path: navigation.complaints.id.messages.path,
              element: <ComplaintActivity />,
            },
          ],
        },
        {
          path: navigation.complaints.id.path + '/legacy',
          element: <ComplaintsShowPage />,
        },
      ],
    },
  ]
}
